module.exports = {
  en: {
    'HRES88EC1': {
      '10': 'Req. Date',
      '20': 'For Department',
      '30': 'Position',
      '40': 'Status',
      '50': 'Remarks',
      '60': 'Last Approver',
      '70': 'Req. No.',
      '80': 'Next Step Approval'
    },
    'HRES88EC2': {
      '10': 'Request By',
      '20': 'Req. Date',
      '25': 'Req. No.',
      '30': 'For Department',
      '40': 'Position',
      '50': 'Req.No.',
      '60': 'Job Description',
      '70': 'No.of Emp.Req.',
      '80': 'Type of Employment',
      '90': 'Req.Date',
      '100': 'Employment Period',
      '110': 'Yrs.',
      '120': 'Month',
      '130': 'Salary',
      '140': 'Reason of Request',
      '150': 'Recruit From',
      '160': 'Internal',
      '170': 'External',
      '180': 'Cause',
      '190': 'Qualification Requirement',
      '200': 'As Specify in Job Code',
      '210': 'New Criteria',
      '220': 'Remarks'
    }
  },
  th: {
    'HRES88EC1': {
      '10': 'วันที่ขอ',
      '20': 'สำหรับหน่วยงาน',
      '30': 'ตำแหน่ง',
      '40': 'สถานะ',
      '50': 'หมายเหตุ',
      '60': 'ผู้อนุมัติล่าสุด',
      '70': 'ลำดับที่',
      '80': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRES88EC2': {
      '10': 'ขออนุมัติโดย',
      '20': 'วันที่ขอ',
      '25': 'ลำดับที่',
      '30': 'สำหรับหน่วยงาน',
      '40': 'ตำแหน่ง',
      '50': 'เลขที่ใบขออนุมัติ',
      '60': 'ลักษณะงาน',
      '70': 'จำนวนที่ขอ',
      '80': 'ประเภทการจ้างงาน',
      '90': 'วันที่ต้องการ',
      '100': 'กำหนดการจ้างงาน',
      '110': 'ปี',
      '120': 'เดือน',
      '130': 'เงินเดือน',
      '140': 'สาเหตุการขอ',
      '150': 'ขอจาก',
      '160': 'ภายใน',
      '170': 'ภายนอก',
      '180': 'เนื่องจาก',
      '190': 'คุณสมบัติที่ต้องการ',
      '200': 'ตามที่ระบุในลักษณะงาน',
      '210': 'กำหนดขึ้นใหม่',
      '220': 'หมายเหตุ'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres88e.js